module.exports = __webpack_public_path__ + "media/images/round-dashboard-d797c388a97a0816452180b7cef64bd3.png";